import React from 'react';
import { experience } from '../data';
import './Experience.css';

export default function Experience() {
  const newestFirst = [...experience].reverse();

  return (
    <section id="experience" className="section" data-scene="rainier">
      <div className="panel">
        <div className="section-head">
          <h2 className="section-head__title">The route</h2>
          <p className="section-head__sub">Where I’ve worked, most recent first.</p>
        </div>

        {/* A dashed trail with a waypoint per job */}
        <ol className="trail">
          {newestFirst.map((j) => (
            <li key={j.id} className="trail__stop">
              <header className="trail__head">
                <h3 className="trail__company">{j.company}</h3>
                <span className="trail__dates">{j.dates}</span>
              </header>
              <p className="trail__role">
                {j.role}
                {j.stints && <> · {j.stints}</>} · {j.location}
              </p>
              <ul className="trail__bullets">
                {j.bullets.map((b) => <li key={b}>{b}</li>)}
              </ul>
              <ul className="stack" aria-label="Tools used">
                {j.stack.map((t) => <li key={t}>{t}</li>)}
              </ul>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
